// Downscale a photo (File from camera/gallery) client-side before uploading it
// as base64 JSON. Keeps uploads small enough for the backend body limit while
// staying sharp enough to judge a defect.
const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

export const downscaleImageToBase64 = file =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
        const width = Math.max(1, Math.round(img.width * scale));
        const height = Math.max(1, Math.round(img.height * scale));

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);

        const dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
        URL.revokeObjectURL(objectUrl);
        resolve({
          fileName: (file.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg',
          contentType: 'image/jpeg',
          dataBase64: dataUrl.split(',')[1],
        });
      } catch (err) {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Bild konnte nicht gelesen werden'));
    };
    img.src = objectUrl;
  });
